export const USER_INSPECTION_SUCCESS = 'BID_INSPECTION_COMPLETE_INSPECTION'
export const USER_INSPECTION_DOWNLOAD_SUCCESS = 'BID_INSPECTION_DOWNLOAD_INSPECTION'
export const USER_CREATE_INSPECTION_SUCCESS = 'BID_INSPECTION_CREATE_INSPECTION'
export const USER_SCHEDULE_INSPECTION = 'BID_INSPECTION_SCHEDULE_INSPECTION'
export const NEW_INSPECTION_SELECT_CLIENT = 'BID_INSPECTION_SELECT_CLIENT'
export const NEW_INSPECTION_CREATE_NEW_CLIENT ='BID_INSPECTION_CREATE_NEW_CLIENT'
export const INSPECTION_CLONE_SUCCESS = 'BID_INSPECTION_CLONE_INSPECTION'
export const INSPECTION_ARCHIVE_SUCCESS ='BID_INSPECTION_ARCHIVE_INSPECTION'